import { connect } from 'react-redux';

import { getEnvironment } from '~/store/selectors';
import { actions as dataFetchActions } from '@bufferapp/async-data-fetch';
import { SEGMENT_NAMES } from '~/constants';
import { getURL } from '~/server/formatters';

import { actions } from './reducer';
import DraftList from './components/DraftList';
import { formatPostLists } from './helpers';

export default connect(
  (state, ownProps) => {
    const { profileId, tabId } = ownProps;
    const currentProfile = state.drafts.byProfileId[profileId];
    if (currentProfile) {
      const { isDisconnected, isManager } =
        state.profileSidebar.selectedProfile;
      const {
        hasFirstCommentFeature,
        showStartBusinessTrialCta,
        hasApprovalFeature,
      } = state.organizations.selected || {};
      return {
        shouldResetComposerData: state.drafts.shouldResetComposerData,
        manager: isManager,
        drafts: currentProfile.drafts,
        postLists: formatPostLists(
          state.profileSidebar.selectedProfile,
          currentProfile.drafts,
          state.user,
          tabId,
          hasApprovalFeature
        ),
        loading: currentProfile.loading,
        loadingMore: currentProfile.loadingMore,
        moreToLoad: currentProfile.moreToLoad,
        page: currentProfile.page,
        total: currentProfile.total,
        showComposer: state.drafts.showComposer,
        environment: getEnvironment(state),
        editMode: state.drafts.editMode,
        editingPostId: state.drafts.editingPostId,
        isDisconnectedProfile: isDisconnected,
        showStartBusinessTrialCta,
        hasFirstCommentFlip: hasFirstCommentFeature,
        profileId: ownProps.profileId,
        trackingCta:
          tabId === 'drafts'
            ? SEGMENT_NAMES.DRAFTS_PAYWALL_UPGRADE
            : SEGMENT_NAMES.AWAITING_APPROVAL_PAYWALL_UPGRADE,
      };
    }
    return {};
  },
  (dispatch, ownProps) => ({
    fetchDrafts: ({ needsApproval }) => {
      dispatch(
        dataFetchActions.fetch({
          name: 'draftPosts',
          args: {
            profileId: ownProps.profileId,
            isFetchingMore: false,
            needsApproval,
            clear: true,
          },
        })
      );
    },
    onApproveClick: (draft) => {
      const draftApproved = draft.draft;
      dispatch(
        actions.handleApproveClick({
          draft: draftApproved,
        })
      );
    },
    onRequestApprovalClick: (draft) => {
      dispatch(
        actions.handleRequestApprovalClick({
          draft: draft.draft,
          profileId: ownProps.profileId,
          needsApproval: true,
        })
      );
    },
    onRevertApprovalClick: (draft) => {
      dispatch(
        actions.handleRequestApprovalClick({
          draft: draft.draft,
          profileId: ownProps.profileId,
          needsApproval: false,
        })
      );
    },
    onRescheduleClick: (draft) => {
      dispatch(
        actions.handleRescheduleClick({
          draft: draft.draft,
          profileId: ownProps.profileId,
        })
      );
    },
    onEditClick: ({ post }) => {
      dispatch(
        actions.handleEditClick({
          draft: post,
          profileId: ownProps.profileId,
        })
      );
    },
    onDeleteConfirmClick: ({ post }) => {
      dispatch(
        actions.handleDeleteConfirmClick({
          draft: post,
          profileId: ownProps.profileId,
        })
      );
    },
    onComposerPlaceholderClick: () => {
      dispatch(
        actions.handleComposerPlaceholderClick({
          profileId: ownProps.profileId,
          cta: SEGMENT_NAMES.CREATE_A_DRAFT,
        })
      );
    },
    onComposerCreateSuccess: () => {
      dispatch(actions.handleComposerCreateSuccess());
    },
    onConfirmDismissComposer: () => {
      dispatch(actions.handleComposerCreateSuccess());
    },
    onStartTrialClick: () => {
      window.location.assign(
        `${getURL.getStartTrialURL({
          trialType: 'small',
          cta: SEGMENT_NAMES.DRAFTS_SBP_TRIAL,
          nextUrl: 'https://publish.buffer.com',
        })}`
      );
    },
  })
)(DraftList);

// export reducer, actions and action types
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
